import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const useGraphsWidgetsWidths = () => {
  const theme = useTheme();

  const isXS = useMediaQuery(theme.breakpoints.down('sm')); // 0–600
  const isSM = useMediaQuery(theme.breakpoints.between('sm', 'md')); // 600–900
  const isMD = useMediaQuery(theme.breakpoints.between('md', 'lg')); // 900–1350
  const isLG = useMediaQuery(theme.breakpoints.up('lg')); // 1350+

  const getWidth = ({ xs, sm, md, lg }: { xs: number; sm: number; md: number; lg: number }) => {
    if (isXS) return xs;
    if (isSM) return sm;
    if (isMD) return md;
    if (isLG) return lg;
    return lg;
  };

  return {
    subscriptionStatusWidth: getWidth({ xs: 1, sm: 1, md: 0.5, lg: 0.33 }),
    statusWidth: getWidth({ xs: 1, sm: 1, md: 0.5, lg: 0.17 }),
    performanceWidth: getWidth({ xs: 1, sm: 1, md: 0.5, lg: 0.5 }),
    usageWidth: getWidth({ xs: 1, sm: 1, md: 0.5, lg: 0.5 }),
  };
};
